import React,{useEffect} from 'react'
import { useDispatch,useSelector } from 'react-redux';
import { loginForum,forumAuth,logout } from 'redux/actions/auth';
import { getForumFilter } from 'redux/actions/forum';
import { setPersist } from 'redux/actions/persist';
import { isMobile } from 'react-device-detect';
import { css } from "@emotion/react";
import BeatLoader from "react-spinners/BeatLoader";
import './style.css'
const override = css`
    position: fixed;
    z-index: 500;
    height: 100vh;
    width: 100%;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index:2000;
`;
const Loader=({isLoading})=>{
    return(
        <BeatLoader
            size={30}
            margin={2}
            color={"#ff4e4e"}
            loading={isLoading}
            css={override}
        />
    )
}
export default function Index(props) {
    const dispatch = useDispatch()
    const general = useSelector(state => state.general)
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const token = params.get('token');
        const formId = params.get('id');
        const action = params.get('action');
        const channelId = params.get('channelId');
        let data={
            token:token,
            DeviceId:isMobile?2:1,
            SourceId:0
        }
        if(token!==null){
            if(formId!==null){
                dispatch(setPersist({forum_id:formId}))
                dispatch(setPersist({filter_action:action}))
                dispatch(setPersist({channel_id:channelId}))
                redirectIfHaveId(data,formId,action,channelId)
            }else{
                if(channelId!==null){
                    redirectIfDontHaveId(data)
                }else{
                    redirectQubisaUser(data)
                }
            }
        }else{
            if(props.token){
                // console.log(`props.token`, props.token)
                window.location.assign('/forum')
            }else{
                dispatch(logout())
            }
        }
        // console.log(`props.token`, props.token)
        // if(props.token){
        //     window.location.assign('/forum')
        // }else{
            
        // }
        
        
    }, [])
    const redirectIfHaveId=async (data,forumId,action,channelId)=>{
        
        let res=await dispatch(loginForum(data))
        if(res){
            if(forumId!=='false'){
                // alert('sdf')
                // console.log(`forumId`, forumId)
                let res2=await dispatch(forumAuth(forumId,res.data.accessToken.token))
                if(res2){
                    window.location.assign('/forum')
                }
            }else{
                let res2=await dispatch(getForumFilter(res.data.accessToken.token))
                if(res2){
                    let {home}=res2.data
                    await dispatch(forumAuth(home[0].forumId,res.data.accessToken.token))
                    dispatch(setPersist({forum_id:home[0].forumId}))
                }
                window.location.assign('/forum')


            }
            
        }
    }
    const redirectIfDontHaveId=async (data)=>{
        let res=await dispatch(loginForum(data))
        if(res){
            window.location.assign('/forum')
        }
    }
    const redirectQubisaUser=async (data)=>{
        let res=await dispatch(loginForum(data))
        if(res){
            dispatch(setPersist({filter_action:'home'}))
            window.location.assign('/forum')
        }
    }
    return (
        <div>
            <Loader isLoading={general.isLoadingTable}/>
        </div>
    )
}
